<template>
  <div class="clear">
    <b-ace-editor :readonly="disabled" :snippets="false" :value="value" :height="height" @input="$emit('input', $event)" lang="sql"> </b-ace-editor>
    <a-alert v-if="showError" :message="msg" type="error" closable @close="onClose" />
  </div>
</template>
<script>
import Vue from 'vue';
import Editor from 'bin-ace-editor';
require('brace/ext/language_tools');
require('brace/mode/sql');
require('brace/snippets/sql');
require('brace/theme/chrome');
Vue.component(Editor.name, Editor);
export default {
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '200'
    }
  },
  data() {
    return {
      showError: false
    };
  },
  methods: {
    async formatSql() {
      let res = {};
      if (res) {
        this.$emit('input', res.payload);
      }
    },
    clearAll() {
      this.$emit('input', '');
      this.showError = false;
      this.$emit('clear');
    },
    async checkSql() {
      this.showError = false;
      this.msg = '';
      let res = {};
      let { header } = res;
      if (header.code == 500) {
        this.showError = true;
        this.msg = header.msg;
      } else {
        this.$message.success('语法正确');
      }
    },
    onClose() {
      this.showError = false;
    },
    run() {
      this.$emit('run');
    }
  }
};
</script>
<style lang="less">
.clear {
  clear: both;
}
</style>
